// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"11":"membercard","95":"handle-transfer","443":"about","571":"settings","584":"block","805":"transactions","809":"transfer"}[chunkId] + "-legacy." + {"11":"05ec3f9b","95":"53aad1de","443":"dfc28d2e","571":"039dfa4f","584":"f42761bc","805":"95858355","809":"c31c77b7"}[chunkId] + ".js";
};